import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail('');
    }, 1500);
  };

  if (isSubscribed) {
    return (
      <div className="bg-success/10 border border-success/20 rounded-lg p-6">
        <div className="text-center">
          <div className="w-12 h-12 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="CheckCircle" size={24} className="text-success" />
          </div>
          <h3 className="text-lg font-heading font-semibold text-success mb-2">
            ¡Suscripción Exitosa!
          </h3>
          <p className="text-sm text-text-secondary mb-4">
            Recibirás nuestros mejores consejos de mantenimiento cada semana.
          </p>
          <button
            onClick={() => setIsSubscribed(false)}
            className="text-sm text-primary hover:text-primary/80 nav-transition"
          >
            Suscribir otro email
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 border border-primary/20 rounded-lg p-6">
      <div className="text-center mb-4">
        <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-3">
          <Icon name="Mail" size={24} className="text-primary" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
          Newsletter Semanal
        </h3>
        <p className="text-sm text-text-secondary">
          Recibe consejos expertos y guías exclusivas para el cuidado de tu piscina
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="relative">
          <input
            type="email"
            placeholder="tu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 bg-surface border border-border rounded-lg text-text-primary placeholder-text-secondary focus:outline-none focus:border-primary nav-transition"
          />
        </div>
        
        <button
          type="submit"
          disabled={isLoading || !email.trim()}
          className="w-full bg-primary text-white px-4 py-3 rounded-lg font-medium hover:bg-primary/90 nav-transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
        >
          {isLoading ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Suscribiendo...</span>
            </>
          ) : (
            <>
              <Icon name="Send" size={16} />
              <span>Suscribirse Gratis</span>
            </>
          )}
        </button>
      </form>

      <div className="mt-4 text-center">
        <p className="text-xs text-text-secondary">
          Sin spam. Cancela cuando quieras.
        </p>
        <div className="flex items-center justify-center space-x-4 mt-2 text-xs text-text-secondary">
          <div className="flex items-center space-x-1">
            <Icon name="Users" size={12} />
            <span>500+ suscriptores</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Star" size={12} />
            <span>Contenido exclusivo</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSignup;